import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idCategoriesUpdate } from '../../../adminSlice';

export default class InputFormsForCategories  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            userInputId: '',
            userInputContent: '',
           
          
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            main_id: this.props.adminState.selectedId,
            main_name: this.state.userInputContent,
            
        }
        console.log(item);
        dispatch(idCategoriesUpdate(item));  
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}



// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
    //let  data =  this.props.data;
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openInputFormsForCategories) {
        return(
            <div className="InputFormsForQuizes">
                <p>Изменить название категории:</p>
                <p className='p-text'>id: {this.props.adminState.selectedId}</p>
                <p className='p-text'>Старое название: {this.props.adminState.dataCategories.map(item => {
              // console.log(item)
                if (item.id === Number(this.props.adminState.selectedId))
               //console.log(item.label)
                {return item.label;} else return null;
                })}
                </p>
                


             
             <form>
                 <label>
                     Введите новое название: </label>
                 <input id="content" type="text"  onChange={this.handleUserInputContent} 
                 />
                 


             </form>
             <button onClick={this.onSend}>OK</button>
             <button onClick={this.onClose}>Закрыть</button>
            </div>
        )
     } else return null;
       
     

        
    }
}